export function getIsPrerenderUserAgent() {
  return getIsUserAgent(/prerender/i);
}

export function getIsEcosystemSocialScreenshotUserAgent() {
  return getIsUserAgent(/Ecosystem-Social-Screenshot/i);
}

export function getIsChromeUserAgent() {
  return getIsUserAgent(/chrome/i);
}

export function getIsMarketplaceUrlsScreenshotUserAgent() {
  return getIsUserAgent(/MarketplaceUrls-Screenshot/i);
}

function getIsUserAgent(userAgent: RegExp) {
  return userAgent.test(navigator.userAgent);
}
